import { combineReducers } from '@reduxjs/toolkit'
import {
  AuthReducer,
  CreateFormFieldsReducer,
  DiagnosticsReducer,
  QuestionnaireReducer,
  PincodeReducer,
  FoodScanReducer,
  SnackbarReducer,
} from './slices'

const rootReducer = combineReducers({
  auth: AuthReducer,
  questionnaire: QuestionnaireReducer,
  diagnostics: DiagnosticsReducer,
  pincode: PincodeReducer,
  formPayload: CreateFormFieldsReducer,
  foodScan: FoodScanReducer,
  snackbar: SnackbarReducer,
})

export default rootReducer
